module.exports = __webpack_public_path__ + "static/media/NunitoSans_7pt-Regular.b31d295e.ttf";